import React from 'react';
import { Link } from 'gatsby';

type SmartLinkProps = {
  to: string;
  children: React.ReactNode;
  className?: string;
  [key: string]: any;
};

export const SmartLink = ({ to, children, className, target, ...props }: SmartLinkProps) =>
  to.startsWith('http') ? (
    <a href={to} className={className} target={target ? target : '_blank'} rel="noopener noreferrer" {...props}>
      {children}
    </a>
  ) : (
    <Link to={to} className={className} target={target ? target : undefined} {...props}>
      {children}
    </Link>
  );
